/**
 * Counts down the label of a cart offer (snippets/cart-offer-card) to the offer's end date.
 *
 * data-ends-at holds a Unix timestamp that Liquid parsed in the shop's timezone, so every visitor counts towards the
 * same moment. Once it passes, the whole offer card is hidden: the server already leaves expired offers out, this only
 * covers a drawer that was rendered before the deadline and is still open.
 */

function pad(value) {
  return String(value).padStart(2, '0');
}

class CartOfferCountdown extends HTMLElement {
  connectedCallback() {
    this.endsAt = Number(this.dataset.endsAt) * 1000;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.endsAt - Date.now()) / 1000));

    if (remaining === 0) {
      clearInterval(this.interval);
      this.closest('.cart-offers__item')?.setAttribute('hidden', '');
      return;
    }

    // Hours keep counting past 24 (e.g. 52:10:05) rather than switching to days, which is what the design shows.
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    this.querySelector('[data-countdown]').textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}

if (!window.customElements.get('cart-offer-countdown')) {
  window.customElements.define('cart-offer-countdown', CartOfferCountdown);
}
